"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _curry = _interopRequireDefault(require("lodash/curry"));

var _typeFieldsConfig2 = _interopRequireDefault(require("./typeFieldsConfig"));

/**
 * Vraci identy extraktovane ze vstupu.
 *
 * @param {Object | 'codeList' | 'entity'} [fieldsConfig]
 * @param {string} [fieldsConfig.identField='code']
 * @param {string} [fieldsConfig.labelField='label']
 * @param {string | Object | Array<string | Object>} items
 *
 * @returns {function} `(items: string | Object | Array<string | Object>) => string | Array<string>`
 */
var _default = (0, _curry.default)(function ensureIdentity(fieldsConfig, items) {
  var _typeFieldsConfig = (0, _typeFieldsConfig2.default)(fieldsConfig),
      identField = _typeFieldsConfig.identField;

  var convert = function convert(c) {
    return typeof c === 'string' ? c : c[identField];
  };

  if (Array.isArray(items)) return items.map(convert);
  return items ? convert(items) : null;
});

exports.default = _default;